import { DDMMYYYYHHMMAFormat } from "app/_helpers/dateHelper";
import { formatDDMMYYYYbyYYYYMMDD, userDropdownLabel } from "app/_helpers/helper";
import React, { useEffect, useState } from "react";
import { Button, Col, Row, Tooltip } from "react-bootstrap";
import { OverlayTrigger } from "react-bootstrap";
import { FiCheckCircle, FiXCircle } from "react-icons/fi";
import { Link } from "react-router-dom";
import Decline from "./IncidentManagement/DeclinePopup";
import Srcollbar from "react-perfect-scrollbar";

const CapasViewTable = ({ capas = [], approveRejectView, approveCapa, form }) => {
  return (
    <div className="table-responsive">
      <Srcollbar className="workoverCategoryScroll">
        <table id="capas_table" className="table table-bordered mb-0">
          <thead>
            <tr>
              <th scope="col">S.No.</th>
              <th scope="col" style={{ minWidth: 200 }}>
                CAPA ID
              </th>
              <th scope="col" style={{ minWidth: 200 }}>
                CAPA Type
              </th>
              {/* <th scope="col">CAPA Description</th> */}
              {form?.reportAtLabel !== "ro" && (
                <>
                  <th scope="col" style={{ minWidth: 150 }}>
                    Area
                  </th>
                  <th scope="col" style={{ minWidth: 150 }}>
                    Sub Area
                  </th>
                </>
              )}
              <th scope="col" style={{ minWidth: 260 }}>
                CAPA Owner
              </th>
              <th scope="col" style={{ minWidth: 120 }}>
                CAPA Priority
              </th>
              {/* <th scope="col" style={{ minWidth: 130 }}>
                Due Date&nbsp;
                <CustomPopover
                  placement={"right"}
                  tooltip={
                    <>
                      <table className="table table-bordered tooltipTable">
                        <thead>
                          <tr>
                            <th>CAPA Priority</th>
                            <th>Due Date Guideline</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isArray(CAPA_DUE_DATE_GUIDE_LINE) &&
                            CAPA_DUE_DATE_GUIDE_LINE.map((data) => {
                              return (
                                <tr>
                                  <td>{data.priority}</td>
                                  <td>
                                    {data.dueDate}
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </>
                  }
                >
                  <BsFillInfoCircleFill />
                </CustomPopover>
              </th> */}
              <th scope="col" style={{ minWidth: 130 }}>
                CAPA Completion Date
              </th>
              <th scope="col" style={{ minWidth: 130 }}>
                Status
              </th>
              {/* <th scope="col" style={{ minWidth: 130 }}>
                    CAPA Completion Proof
                  </th>
                  <th scope="col" style={{ minWidth: 130 }}>
                    Remarks
                  </th> */}
              {/* <th scope="col" style={{ minWidth: 120 }}>
                            Owner Department
                        </th> */}
              {/* {!viewOnly && <th scope="col">Remove</th>} */}
            </tr>
          </thead>
          <tbody>
            {capas.map((x, index) => (
              <tr key={index}>
                <th>{index + 1}</th>
                <th>
                  <p>
                    <Link
                      target="_blank"
                      to={`/health-safety-and-environment/capa-management/manage-capa/update/${x?.id}`}
                    >
                      {x?.capaId}
                    </Link>
                  </p>
                </th>
                <td>{x?.capaType}</td>

                {form?.reportAtLabel !== "ro" && (
                  <>
                    <td>
                      {x?.subAreaId === 999 ? x?.workArea?.name : x?.subArea?.area?.name}
                    </td>
                    <td>
                      <Row>
                        <Col lg={12}>
                          {x?.subAreaId === 999 ? "Other" : x?.subArea?.name}
                        </Col>
                      </Row>
                      {x?.subAreaId === 999 && (
                        <Row>
                          <Col lg={12}>
                            <strong>Other Sub Area</strong>
                            <p>{`${x?.otherSubArea}`}</p>
                          </Col>
                        </Row>
                      )}
                    </td>
                  </>
                )}

                <td>{userDropdownLabel(x?.owner)}</td>

                <td>{x.priority}</td>

                <td>
                  {x?.completionDate
                    ? DDMMYYYYHHMMAFormat(x?.completionDate)
                    : x?.completionDate}
                </td>
                <td>{x?.capaStatus}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Srcollbar>
    </div>
  );
};

export default CapasViewTable;
